import { ClientPortalLoginAdapter } from '~/apps/main/ClientPortal/services/adapters/client-portal-login.adatper';

export class ClientPortalLoginService extends ClientPortalLoginAdapter {}
